<script lang="ts">
	import { onMount } from 'svelte';
	import type { HTMLAttributes } from 'svelte/elements';
	import { fade } from 'svelte/transition';

	let container = $state<HTMLDivElement>();

	onMount(() => {
		if (container) {
			document.body.appendChild(container);
		}

		return () => {
			container?.remove();
		};
	});

	let { children }: HTMLAttributes<HTMLDivElement> = $props();
</script>

<div
	bind:this={container}
	transition:fade={{ duration: 240 }}
	class="pointer-events-none fixed inset-0 z-[60] bg-black/50"
>
	{@render children?.()}
</div>
